/**
 * @generated SignedSource<<db514045f0c27bda4ef37e91c388ab8b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentLabelSelectorDropdownListFragment$data = {
  readonly contentLabels: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ContentLabelSelectorDropdownListItemFragment">;
      };
    }>;
  };
  readonly id: string;
  readonly " $fragmentType": "ContentLabelSelectorDropdownListFragment";
};
export type ContentLabelSelectorDropdownListFragment$key = {
  readonly " $data"?: ContentLabelSelectorDropdownListFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentLabelSelectorDropdownListFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentLabelSelectorDropdownListFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentLabelNodeConnection",
      "kind": "LinkedField",
      "name": "contentLabels",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentLabelNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentLabel",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ContentLabelSelectorDropdownListItemFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "96a3c6e6b3a37521d0723d875aeb1c6d";

export default node;
